import React, { useState, useEffect } from 'react';
import { Container, Row, /*Col, Form*/ } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
/*import RoleUtils from '../utils/roleUtils.js';*/
import { RequestActionButtons } from '../components/RequestActionButtons'
/*import { Link } from 'react-router-dom';*/
import { useParams } from 'react-router-dom';
import '../styles/Vendor.css';
import { Loading } from '../components/Loading';
import WorklistComments from '../components/WorklistComments';
import WorklistAttachments from '../components/WorklistAttachments.js';
import WorklistRequestDetails from '../components/WorklistRequestDetails';

 export const VendorBankRequest= (props)=> { 
    const [hasAccess, setHasAccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [firstLoad, setFirstLoad] = useState(false);
    const [request, setRequest] = useState({});
    const [currentCompanyId, setCurrentCompanyId] = useState(0);
    const { requestId } = useParams();

    useEffect(() => {  
        if (props.currentCompanyId !== currentCompanyId) {  
            setHasAccess(false);  
            setIsLoading(true);  
            setCurrentCompanyId(props.currentCompanyId)  
            getRequest(props.currentCompanyId);  
        }  
        setFirstLoad(true);  
    }, []);  
      
    useEffect(() => {  
        if (firstLoad) {  
            setNotificationViewed();  
        }  
    }, [firstLoad]);  
    
  
    const getRequest =(supplierId) => {
        /*const { currentUser } = props;*/
        if(!firstLoad){
            setIsLoading(true);
        }
        var currentSupplierId = Number(supplierId);
        ServiceCalls.checkWorklistAccess(currentSupplierId).then(function (data) {
            if (data) {              
                ServiceCalls.getBankRequestById(currentSupplierId,Number(requestId)).then(function (results) {                  
                    if (results && results.isSuccessful) {  
                        //DEBUG console.log(`have request ${requestId}  ${JSON.stringify(results)}`);
                        setHasAccess(data);
                        setIsLoading(false);
                        setRequest(results);
                    }
                    else {
                        setHasAccess(data);
                        setIsLoading(false);
                    }
                });
            }
            else {
                setHasAccess(false);
                setIsLoading(false);
            }
        });
     };
    const updateRequest = () => {
        setIsLoading(true);
         getRequest(currentCompanyId);
     }

     const setNotificationViewed = () => {  
        // DE784129: Flag Never Decreases 
        // Added error checking
        ServiceCalls.setBankRequestNotificationViewed(requestId)  
            .then(response => {  
                if (response === true) {  
                    console.log("Successfully set notification as viewed.");  
                } else {  
                    console.error("Failed to set notification as viewed. Response was not true.");  
                }  
            })  
            .catch(error => {  
                console.error("Error occurred while setting notification as viewed:", error);  
            });  
    }  
    

    return (
        (isLoading)
            ? <div style={{ margin: "auto", width: "250px" }}>
                <h3 className="primaryText">Request Details</h3>
                <Loading />
            </div>
            : (hasAccess === true && request)
                ?   
                <Container fluid>
                    <Row style={{ marginBottom: "20px",marginTop:"25px" }}>
                        <WorklistRequestDetails Request={request} currentUser={props.currentUser} currentCompanyId={currentCompanyId} />
                        <WorklistComments Request={request} currentUser={props.currentUser} currentCompanyId={currentCompanyId} refresh={getRequest} />
                        <WorklistAttachments Request={request} currentUser={props.currentUser} currentCompanyId={currentCompanyId} refresh={getRequest}/>
                        </Row>
                        <RequestActionButtons currentUser={props.currentUser} currentRequest={request} currentCompanyId={currentCompanyId} onRequestAction={updateRequest} />             
                </Container>
                :   <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>
    );
    
}

